import { Empty } from "antd";

function ExternalPDFPage6Table3(props: any) {
    return (
        <>
            <table className="table table-sm table-bordered cu-table-border table-striped cu-fs-10">
                <thead>
                    <tr className="">
                        <th colSpan={9}>
                            {props.TranslateString('apartments_pdf')}
                        </th>
                    </tr>
                    <tr className="cu-bg-green  ">
                        <th className="text-right text-nowrap fw-600">{props.TranslateString('Total m2 (summarized)')}</th>
                        <th className="text-right text-nowrap fw-600">{props.TranslateString('Total number of apartments')}</th>
                        <th className="text-right text-nowrap fw-600 text-nowrap" style={{minWidth:'110px'}}>{props.TranslateString('e/m2 average')}</th>
                        <th className="text-right text-nowrap fw-600">{props.TranslateString('estimated value, average ')}</th>
                        <th className="text-right fw-600">{props.TranslateString('estimated value, lower quartile')}</th>
                        <th className="text-right fw-600">{props.TranslateString('estimated value, upper quartile')}</th>
                        <th className="text-right text-nowrap fw-600">{props.TranslateString('Number of sales')}</th>
                        <th className="text-right text-nowrap fw-600">{props.TranslateString('Estimation basis')}</th>
                    </tr>
                </thead>
                {/* <tbody className="bg-light">
                    {props?.data?.length > 0 ? props?.data?.map((val: any) => {
                        return (
                            <tr className='text-left' key={Math.random()}>
                                <td className="text-right">{val.sale_data_num_rooms}</td>
                                <td className="text-right">{val.surface_area}</td>
                                <td className="text-right">{val.no_apartments}</td>                                                               
                                <td className="text-right">{val.avg_price}</td>
                                <td className="text-right">{val.indicative_price}</td>
                                <td className="text-right">{val.quartile_25}</td>
                                <td className="text-right">{val.quartile_75}</td>
                                <td className="text-right">{val.sale_no}</td>
                                <td className="text-right">{val.estimation}</td>
                            </tr>
                        )
                    }) : <tr><td colSpan={9}><Empty description={props.TranslateString('Empty')}/></td></tr>}
                </tbody> */}
                <tfoot>
                    {props?.ltvDetails?.apartment_data?.length > 0 || props?.ltvDetails?.apartment_total ?
                        <tr className='bg-light'>
                            <td className="text-right fw-600">{props?.ltvDetails?.apartment_total?.total_surface}</td>
                            <td className="text-right fw-600">{props?.ltvDetails?.apartment_total?.no_apartments_total}</td>
                            <td className="text-right fw-600">{props?.ltvDetails?.apartment_total?.price_total}</td>
                            <td className="text-right fw-600">{props?.ltvDetails?.apartment_total?.indicative_price_total}</td>
                            <td className="text-right fw-600">{props?.ltvDetails?.apartment_total?.quartile_25_total}</td>
                            <td className="text-right fw-600">{props?.ltvDetails?.apartment_total?.quartile_75_total}</td>
                            <td className="text-right fw-600">{props?.ltvDetails?.apartment_total?.total_sale_no}</td>
                            <td className="text-right fw-600">{props?.ltvDetails?.apartment_total?.estimation}</td>
                        </tr>
                        : ""}
                </tfoot>
            </table>
        </>
    );
}

export default ExternalPDFPage6Table3;